import { ApiProperty } from '@nestjs/swagger';
import { Type } from 'class-transformer';
import { IsBoolean, IsDate, IsOptional, IsString, MaxLength } from 'class-validator';

export class UpdateProveedorMarcaDto {
  @ApiProperty({ required: false })
  @IsOptional()
  @IsBoolean()
  es_distribuidor_oficial?: boolean;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsBoolean()
  es_proveedor_preferente?: boolean;

  @ApiProperty({ required: false })
  @IsOptional()
  @Type(() => Date)
  @IsDate()
  vigente_desde?: Date;

  @ApiProperty({ required: false })
  @IsOptional()
  @Type(() => Date)
  @IsDate()
  vigente_hasta?: Date;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString()
  @MaxLength(500)
  observacion?: string;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsBoolean()
  activo?: boolean;
}
